<!--
 * @Description  : 文库具体详情页
 * @Author       : 王帅
 * @Date         : 2024-09-25 16:12:55
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-27 16:38:59
 * @FilePath     : \ngs_platform_manage_admin\src\views\library-server\library-detail.vue
-->
<template>
	<div class="main-container library-detail"
		 ref="mainBox">
		<div class="detail-header">
			<!-- <div class="detail-header-qrcode"
				 v-if="isDownloadMain && params.value !== ''">
				<div class="qrcode-tips">扫码下载</div>
				<vue-qr :text="params.value"
						:size="params.size"></vue-qr>
			</div> -->
			<div class="detail-header-form">
				<el-form display-only
						 label-width="130px"
						 v-model="pageInfo">
					<el-row noSpace>
						<el-col :span="12">
							<el-form-item label="法律效力位阶："
										  prop="rangeType">
								<span>{{ pageInfo.lawRankName || '-' }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="施行日期： "
										  prop="applyDate">
								<span>{{ pageInfo.applyDate || '-' }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="颁布机关："
										  prop="issueUnit">
								<span>{{ pageInfo.issueUnit || '-' }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="公示日期："
										  prop="releaseDate">
								<span>{{ pageInfo.releaseDate || '-' }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="时效性："
										  prop="efficientName">
								<span>{{ pageInfo.efficientName || '-' }}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="所属分类："
										  prop="title">
								<el-tooltip :visible="showTips ? 'always' : 'auto'"
											:content="pageInfo.typeName"
											:disabled="!pageInfo.typeName">
									<div class="max-text">
										<!-- <p class="max-text">{{ pageInfo.typeName }}</p> -->
										<span ref="activeTipText">{{ pageInfo.typeName || '-' }}</span>
									</div>
								</el-tooltip>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
		<div class="detail-nav">
			<div class="detail-nav-leftTabs">
				<span :class="{ 'active-tab': activeTab === item.value }"
					  v-for="(item, index) in showTabsList"
					  :key="'showTab' + index"
					  @click="activeTab = item.value">{{ item.value == '1001033003' ? `${item.sname}（${pageInfo.otherFile.length || 0}）` : item.sname }}</span>
			</div>
			<div class="detail-nav-rightBtn">
				<span @click="handleDownload('mainFile')"
					  v-if="isDownloadMain">下载正文</span>
			</div>
		</div>
		<section class="detail-content"
				 :class="{ 'auto-height': activeTab !== '1001033002' }">
			<!-- 关键内容 -->
			<template v-if="activeTab == '1001033001'">
				<!-- <div class="quill-editor editor min200 w100 main-content">
					<div class="ql-container">
						<div class="ql-editor">
							<div class="content" v-html="mainContent"></div>
						</div>
					</div>
				</div> -->
				<template v-if="mainContent !== ''">
					<wang-editor style="padding: 70px 90px;"
								 v-model="mainContent"
								 ref="wangEditor"
								 isViewMode
								 noBorder
								 height="100%"></wang-editor>
				</template>
				<div v-else
					 class="no-data">暂无内容</div>
			</template>
			<!-- 文档正文 -->
			<template v-if="activeTab == '1001033002'">
				<template v-if="mainUrl">
					<iframe :src="mainUrl"
							width="100%"
							height="100%"
							style="border: none"></iframe>
				</template>
				<div class="no-data"
					 v-else>暂无数据</div>
			</template>

			<!-- 文档附件 -->
			<div v-if="activeTab == '1001033003'"
				 class="detail-content-table primary-layout">
				<div class="content-header primary-header">
					<span></span>
					<span class="content-header-btn"
						  @click="handleDownload('otherFile')">批量下载</span>
				</div>
				<div class="primary-content w-table-layout mt10">
					<vxe-table ref="otherFileFile"
							   border
							   highlight-hover-row
							   highlight-current-row
							   resizable
							   autoResize
							   row-id="id"
							   height="auto"
							   size="small"
							   class="file-table-library"
							   show-overflow="tooltip"
							   show-header-overflow="tooltip"
							   :data="pageInfo.otherFile"
							   :checkbox-config="{ checkMethod: checkboxMethod }">
						<vxe-table-column field="checkbox"
										  type="checkbox"
										  title=""
										  width="60"
										  align="center"
										  headerAlign="center">
						</vxe-table-column>
						<vxe-table-column field="seq"
										  type="seq"
										  title="序号"
										  width="80"
										  align="center"
										  headerAlign="center"> </vxe-table-column>
						<vxe-table-column field="download"
										  title="操作"
										  width="60"
										  align="center"
										  headerAlign="center">
							<template #default="{ row }">
								<el-button type="text"
										   class="font20"
										   icon="el-icon-download"
										   @click="onClickDownload(row)"
										   v-if="row.isDownload == 1"
										   title="下载">
								</el-button>
							</template>
						</vxe-table-column>
						<vxe-table-column field="fileName"
										  title="文件名称"
										  min-width="300"
										  align="left"
										  headerAlign="left">
							<template v-slot="{ row }">
								<span class="blue-text"
									  @click="previewFile(row)">{{ row.fileName }}</span>
							</template>
						</vxe-table-column>
						<vxe-table-column field="fileSuffix"
										  title="文件格式"
										  min-width="150"
										  align="left"
										  headerAlign="left"></vxe-table-column>
						<vxe-table-column field="fileSize"
										  title="文件大小"
										  min-width="150"
										  align="left"
										  headerAlign="left"></vxe-table-column>
					</vxe-table>
				</div>
			</div>

			<!-- 文档信息 -->
			<div v-if="activeTab == '1001033004'"
				 class="detail-content-form">
				<el-form ref="publish"
						 :model="pageInfo"
						 validate-type="text"
						 class="tableForm">
					<!-- <el-form-item label="所属部门">
						<div class="ml20">{{ pageInfo.deptName }}</div>
					</el-form-item>
					<el-form-item label="所属单位">
						<div class="ml20">{{ pageInfo.tenantName }}</div>
					</el-form-item> -->
					<el-form-item label="创建人">
						<div class="ml20">{{ pageInfo.createUser }}</div>
					</el-form-item>
					<el-form-item label="创建时间">
						<div class="ml20">{{ pageInfo.createDate }}</div>
					</el-form-item>
				</el-form>
			</div>
		</section>

		<!-- 回到顶部 -->
		<div class="to-top"
			 @click="goTop"
			 v-show="showBackTop">
			<svg-icon icon-class="goToTop"></svg-icon>
		</div>
	</div>
</template>

<script>
import * as Api from '@/api/modules/library-server/index.js'
import { exportPlus, bmStorage } from 'utils/tools'
import vueQr from 'vue-qr'
import fileName from '@/components/upload/fileName.vue'

export default {
	components: { vueQr, fileName }, // editor
	name: 'libraryDetail',
	data() {
		return {
			detailId: '', // 主键ID
			activeTab: '1001033001',
			pageInfo: {
				otherFile: []
			},
			mainUrl: '', // 正文地址
			mainContent: '', // 正文地址
			params: {
				value: '',
				size: 100
			},
			showTips: false,
			tabsList: [
				{ sname: '正文信息', value: '1001033001' },
				{ sname: '正文文档', value: '1001033002' },
				{ sname: '相关附件', value: '1001033003' },
				{ sname: '文档信息', value: '1001033004' }
			],
			showTabsList: [], // 实际展示的tab
			isDownloadMain: false, // 是否可以下载正文
			isDownloadOther: false, // 是否可以下载附件
			showBackTop: false
		}
	},
	methods: {
		// 获取数据
		getPageData(id) {
			Api.documentFile({ id: this.detailId || '', alias: this.alias })
				.then((res) => {
					// 展示的tab
					this.showTabsList = this.tabsList.filter((x) =>
						res.data.showTabs.includes(x.value)
					)
					this.activeTab = this.showTabsList[0].value
					// 下载按钮
					this.isDownloadMain = res.data.isDownload == 1

					this.pageInfo = res.data
					this.pageInfo.otherFile = res.data.otherFile || []

					const bodyFileUrl = res.data.bodyFileUrl
					const bodyFileName = res.data.bodyFileName
					// 优化后的构造逻辑
					this.mainUrl = bodyFileUrl
						? `https://wps.52ngs.com/bmfileViewer/onlinePreview?url=${
								bodyFileUrl.includes(bodyFileName)
									? bodyFileUrl
									: bodyFileUrl + bodyFileName
						  }`
						: ''
					this.mainContent = res.data.mainContent
					// this.$refs.editor.content = res.data.mainContent
					// 二维码更新
					this.params.value = bodyFileUrl.includes(bodyFileName)
						? bodyFileUrl
						: bodyFileUrl + bodyFileName

					// 更新 底部记录
					this.$nextTick(() => {
						if (this.$parent) {
							this.$parent.pageFooter.accessTimes =
								res.data.accessTimes || 0
							this.$parent.pageFooter.downloadTimes =
								res.data.downloadTimes || 0
							this.$parent.selectTypes =
								res.data.selectTypes || []
						}

						setTimeout(() => {
							// 看看是否需要文字提示
							if (this.$refs.activeTipText) {
								let height =
									this.$refs.activeTipText.offsetHeight

								if (height >= 72) {
									this.showTips = true
								}
							}
						}, 1000)
					})
				})
				.catch((err) => {})
		},

		// 点击下载
		handleDownload(type) {
			if (type == 'mainFile') {
				if (this.mainUrl == '') {
					this.$message.warning('正文文档不存在')
					return
				}
				let params = {
					alias: this.alias, // 招采文库 暂时写死
					fileId: this.detailId,
					type: 1 // 1 下载 ，0阅读
				}
				Api.saveRead(params).then((res) => {
					this.$downloadFile(
						this.pageInfo.bodyFileUrl.includes(
							this.pageInfo.bodyFileName
						)
							? this.pageInfo.bodyFileUrl
							: this.pageInfo.bodyFileUrl +
									this.pageInfo.bodyFileName,
						this.pageInfo.bodyFileName
					)
				})
			} else {
				let arr = this.$refs.otherFileFile.getCheckboxRecords()
				if (arr.length === 0) {
					this.$message.warning('请先选择文件')
					return
				}
				let ids = arr.map((x) => x.id)
				let params = {
					manageId: this.detailId, //this.$route.query.id,
					attachmentId: ids
				}

				exportPlus(
					'/docManage/downloadAttachment',
					params,
					'',
					'',
					'下载完成！'
				)
			}
		},
		// 单个下载
		onClickDownload(row) {
			this.$downloadFile(row.downloadUrl, row.fileName)
		},

		// 预览
		previewFile(data) {
			if (parseInt(this.fileSize) / 1024 / 1024 > 10) {
				this.$message.warning('该附件过大，请下载后预览。')
				return
			}
			this.$previewFn(data.downloadUrl, data.fileName)
			// window.open(this.$previewUrl + data.downloadUrl, '_blank')
		},

		// 复选框禁用
		checkboxMethod({ row }) {
			return row.isDownload == 1
		},

		onScroll(e) {
			if (
				e.target.scrollingElement &&
				e.target.scrollingElement.scrollTop > 350
			) {
				this.showBackTop = true
			} else {
				this.showBackTop = false
			}
		},

		// 回到顶部
		goTop() {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		}
	},
	created() {
		// 储存一下 detailId
		if (this.$route.query.detailId && !bmStorage.sessionStorage.get('libraryDetailPage')) {
			this.detailId = this.$route.query.detailId
			bmStorage.sessionStorage.set(
				'libraryDetailPage',
				JSON.stringify(this.$route.query)
			)
		} else if (bmStorage.sessionStorage.get('libraryDetailPage')) {
			this.detailId = JSON.parse(
				bmStorage.sessionStorage.get('libraryDetailPage')
			).detailId
		}

		setTimeout(() => {
			!!this.detailId ? this.getPageData() : ''
		}, 500)
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll)
	},
	computed: {
		// 缓存信息 --- 详情页信息
		libraryDetailPage() {
			return bmStorage.sessionStorage.get('libraryDetailPage')
				? JSON.parse(bmStorage.sessionStorage.get('libraryDetailPage'))
				: {}
		},

		// 请求参数的alias
		alias() {
			return (
				this.$route.query.alias ||
				bmStorage.sessionStorage.get('alias') ||
				'xhwk'
			)
		}
	}
}
</script>
<style scoped lang="less">
// 回到顶部
.to-top {
	position: fixed;
	bottom: 90px;
	font-size: 40px;
	margin-left: 1220px;
	cursor: pointer;
	border-radius: 4px;
	box-shadow: 1px 1px 3px 3px #f5f5f5;
}
.font20 {
	font-size: 20px;
	padding: 0 !important;
	color: #456097;
}
/deep/ .vxe-body--row.row--current::after {
	height: 42px !important;
}
/deep/ .w-e-text-placeholder {
	display: none !important;
}
.no-data {
	display: flex;
	height: 300px;
	justify-content: center;
	align-items: center;
	color: #ccc;
}

.file-table-library {
	/deep/ .vxe-cell--checkbox.is--indeterminate .vxe-checkbox--icon,
	/deep/ .vxe-cell--checkbox.is--checked .vxe-checkbox--icon {
		color: #456097 !important;
	}
	/deep/ .vxe-cell--checkbox.is--disabled .vxe-checkbox--icon {
		background-color: #e6dfe680 !important;
	}
}

// 有表格的表单样式
.tableForm {
	/deep/ .el-form-item {
		margin-bottom: 0;
		margin-right: 0;
		display: flex;
	}

	/deep/ .el-form-item__label {
		width: 200px !important;
		border: 1px solid #dcdcdc;
		border-right: 0;
		border-bottom: 0;
		line-height: 46px;
		background: #fafafa;
		padding-right: 20px;
	}

	/deep/ .el-form-item__content {
		border: 1px solid #dcdcdc;
		border-bottom: 0;
		width: calc(100% - 202px);
		background-color: #fff;
		line-height: 46px;
		text-align: left;
	}

	/deep/ .el-form-item:last-child {
		.el-form-item__content,
		.el-form-item__label {
			border-bottom: 1px solid #dcdcdc;
		}
	}

	/deep/ .el-input {
		width: 100%;
	}

	/deep/ .el-input__inner {
		min-height: 46px !important;
		line-height: 46px !important;
		padding-left: 20px;
		border: 0;
		border-radius: 0;
	}
}
.blue-text {
	color: #2671cc !important;
	cursor: pointer !important;
}
.no-data {
	color: #aaa !important;
}
</style>
